require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-the-mills-4-1-th.json") })
        }
      }, "path---news-the-mills-4-1-th");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-the-mills-4-1-th!./.cache/json/news-the-mills-4-1-th.json
// module id = 853
// module chunks = 231608221292675